import React from 'react';

export default React.createContext({}); // argument is the default starting value
